import axiosConfig from "./axiosConfig";
import { AxpoCounterInvoice } from "./axpoCounterInvoiceTypes";

export interface ListAxpoCounterInvoicesResponse {
  axpoCounterInvoices: AxpoCounterInvoice[];
}

const listAxpoCounterInvoices = async (
  authToken: string
): Promise<ListAxpoCounterInvoicesResponse> => {
  const { data } = await axiosConfig.get("/admin/axpo-counter-invoice", {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data;
};

export default listAxpoCounterInvoices;
